<template>
  <div class="expert-address">
    <a-cascader
      :options="addressOptions"
      :loadData="loadData"
      @change="addressChange"
      placeholder="请选择"
      :disabled="disabled"
      v-model="addressVal"
      changeOnSelect
      style="width: 100%"
    />
  </div>
</template>
<script>
import { regions } from '@/serve/regions'
export default {
  name: 'expertAddress',
  props: {
    defaultVal: { // 地区代码 [大区，省，市]
      type: Array,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      defalut: false
    }
  },
  watch: {
    defaultVal (newVal, oldVal) {
      this.addressVal = newVal
    }
  },
  data () {
    return {
      regionList: [],
      addressOptions: [], // 省市县
      defalutAddress: [],
      addressVal: []
    }
  },
  methods: {
    // 动态加载
    async loadData (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true

      await regions({ idParent: selectedOptions[selectedOptions.length - 1].id }).then(res1 => {
        res1.forEach(item => {
          item.value = item.id
          item.label = item.name
          if (item.childrenNum > 0) {
            item.isLeaf = false
          } else {
            item.isLeaf = true
          }
        })
        targetOption.loading = false
        targetOption.children = res1
      })
      this.addressOptions = [...this.addressOptions]
    },

    // 专家所在地选择
    addressChange (value, selectedOptions) {
      let selectList = []
      if (selectedOptions && selectedOptions.length > 0) {
        for (let i = 0; i < selectedOptions.length; i++) {
          let obj = {}
          obj.label = selectedOptions[i].label
          obj.value = selectedOptions[i].value
          obj.idParent = selectedOptions[i].idParent
          selectList.push(obj)
        }
        this.$emit('addressChange', selectList)
      } else {
        this.$emit('addressChange', selectList)
      }
    },

    // 获取地区信息
    getRegion () {
      regions({ idParent: '0' }).then(res1 => {
        console.log('地址信息', res1)
        this.region = res1
        for (let i = 0; i < res1.length; i++) {
          res1[i].value = res1[i].id
          res1[i].label = res1[i].name
          res1[i].isLeaf = false
          // regions({ idParent: res1[i].id }).then(res2 => {
          //   for (let j = 0; j < res2.length; j++) {
          //     res2[j].value = res2[j].id
          //     res2[j].label = res2[j].name
          //   }
          //   res1[i].children = res2
          // })
        }
        // res1.forEach(item => {
        //   item.value = item.id
        //   item.label = item.name
        //   regions({ idParent: item.id }).then(res2 => {
        //     res2.forEach(item2 => {
        //       item2.value = item2.id
        //       item2.label = item2.name
        //     })
        //     res1.children = res2
        //   })
        // })
        this.addressOptions = res1
      })
    },
    regionArraytoTree (data, parentCode) {
      let temp
      let tree = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].parentCode === parentCode) {
          data[i].label = data[i].name
          data[i].value = data[i].code
          let obj = data[i]
          temp = this.regionArraytoTree(data, data[i].code)
          if (temp.length > 0) {
            obj.children = temp
          }
          tree.push(obj)
        }
      }
      return tree
    }
  },
  created () {
    this.getRegion()
  }
}
</script>
<style lang="less">
.ant-cascader-picker-disabled {
  color: #000;
  background: #fff;
}
</style>
